module.exports = __webpack_public_path__ + "../resources/img/ic-re-cancel.5b2a0b96.svg";